<template>
  <div class="widget-wrapper">
    <label v-bind:for="name">{{ label }}</label>
    <select
      v-bind:id="name"
      v-on:input="$emit('input', $event.target.value)"
    >
      <option
        v-for="item in options"
        v-bind:key="item"
        v-bind:selected="item === value"
      >{{ item }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'RingsCalculatorInputNumber',
  props: {
    value: { type: String },
    name: { type: String },
    label: { type: String },
    options: { type: Array }
  },
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .widget-wrapper {
    & > label {
      display: block;
      text-align: left;
      text-transform: uppercase;
      font-family: "Gotham Pro Regular", $font-stack;
      color: $default-heading-color;
      padding-bottom: 0.5em;
    }
    & > select {
      background-color: $content-background-color;
      border: 1px solid $default-text-color;
      color: $default-text-color;
      padding: 0.33em;
      min-width: 120px;
      cursor: pointer;
    }
    font-size: 13px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/RingsCalculatorInputSelectbox.vue